<app-navbar title="Szablony transportów">
	<a routerLink="./add" class="btn btn-primary"> <i class="fas fa-plus"></i> Dodaj </a>
</app-navbar>

<!--
<app-drivers-list-filters
	userFilters="drivers"
	[statuses]="parameters.statuses"
	[yesno]="parameters.yesno"
	[allDrivers]="parameters.drivers"
	(selected)="filtersSelected($event)"
></app-drivers-list-filters>
-->

<app-dynamic-table
	module="transportTemplates"
	[elements]="data"
	[tableRows]="tableRows"
	[haveFilters]="false"
></app-dynamic-table>
